import {
	GET_CASE_DETAILS_REQUEST,
	GET_CASE_DETAILS_REQUEST_FAILED,
	GET_CASE_DETAILS_REQUEST_FAILED_CLEAR,
	GET_CASE_DETAILS_REQUEST_SUCCESS,
} from "../types"

const initialState = {
	isLoading: false,
	caseDetails: {},
}
const bifrostCaseDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CASE_DETAILS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_CASE_DETAILS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				caseDetails: action.payload,
			}
		case GET_CASE_DETAILS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
				caseDetails: {},
			}
		case GET_CASE_DETAILS_REQUEST_FAILED_CLEAR:
			return initialState
		default:
			return state
	}
}

export default bifrostCaseDetailsReducer
